<template>
  <b-card no-body>
    <b-card-header class="pb-50">
      <h5>
        Фильтр
      </h5>
    </b-card-header>
    <b-card-body>
      <b-row>
        <b-col
          cols="12"
          md="4"
          class="mb-md-0 mb-2"
        >
          <label>Период</label>
          <vueflatpickr
            :value="dateFilter"
            class="form-control"
            :config="{ mode: 'range', dateFormat: 'd.m.Y' }"
            @input="(val) => $emit('update:dateFilter', val)"
          />
        </b-col>
        <b-col
          cols="12"
          md="4"
          class="mb-md-0 mb-2"
        >
          <label>Дилер</label>
          <v-select
            label="title"
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            :value="dealerFilter"
            :options="dealerOptions"
            class="w-100"
            :reduce="val => val.value"
            @input="(val) => $emit('update:dealerFilter', val)"
          />
        </b-col>

      </b-row>
    </b-card-body>
  </b-card>
</template>

<script>
import {
  BCard, BCardHeader, BCardBody, BRow, BCol,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import flatpickr from 'flatpickr'
import 'flatpickr/dist/flatpickr.min.css'
// Right way to import locale
import { Russian } from 'flatpickr/dist/l10n/ru'
import Vueflatpickr from 'vue-flatpickr-component'

// default locale is now Russian
flatpickr.localize(Russian)

export default {
  components: {
    BRow,
    BCol,
    BCard,
    BCardHeader,
    BCardBody,
    vSelect,
    Vueflatpickr,
  },
  props: {
    dateFilter: {
      type: [String, null],
      default: null,
    },
    dealerOptions: {
      type: Array,
      required: true,
    },
    dealerFilter: {
      type: [String, null],
      default: null,
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
@import '@core/scss/vue/libs/vue-flatpicker.scss';
</style>
